import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { LzLanguageService } from '../../../../services/lz-language/lz-language.service';
import { Component, Inject, OnInit } from "@angular/core";
import { interval, Observable, Subscription } from "rxjs";

import { LzCookieService } from '../../../../services/lz-cookie/lz-cookie';
import { LzProductConfig } from "../../../../services/product-config/poduct-config";

declare var $: any;

@Component({
  selector: 'app-lz-auth-new',
  template: `<div class="login">
  <div class="lz-logo"><img src="/dist/ng2/src/assets/pl-header-assets/img/cutted-logo.png" alt=""></div>
  <p *ngIf="isSessionOver" class="killed-session-text">{{'user.signinup.authTitle' | translate}}</p>
  <h1 *ngIf="!isSessionOver"><span>{{'user.signinup.enterTo' | translate}}</span><br />{{'user.signinup.liga' |
    translate}}</h1>
  <div class="close" (click)="cancel()"><i class="fa fa-remove"></i></div>
  <form [formGroup]="authForm" (ngSubmit)="signIn()">
    <div class="form-group">
      <input type="email" (change)="isShowErrorLoginAndPassword = false" name="email" [(ngModel)]="userInfo.email"
        class="input-field" id="{{id}}-main-click-field_email-input-popup_login-1" formControlName="email" placeholder="{{'user.signinup.enterEmail' | translate}}"
        [maxlength]="256" required="">
      <div class="error-field" *ngIf="(authForm.get('email').invalid && authForm.get('email').touched)">
        <span *ngIf="authForm.get('email')['errors']['pattern']">{{'user.signinup.emailPattern' | translate}}</span>
      </div>
    </div>
    <div class="form-group">
      <input type="password" (change)="isShowErrorLoginAndPassword = false" name="password" [(ngModel)]="userInfo.password"
        class="input-field" id="{{id}}-main-click-field_password-input-popup_login-1" formControlName="password"
        placeholder="{{'user.signinup.enterPassword' | translate}}" [maxlength]="256" required="">
      <div class="error-field" *ngIf="(authForm.get('password').invalid && authForm.get('password').touched) || isShowErrorLoginAndPassword">
        <span *ngIf="!isShowErrorLoginAndPassword && authForm.get('password')['errors']['pattern']">{{'user.signinup.passwordRequiredPattern'
          | translate}}</span>
        <span *ngIf="isShowErrorLoginAndPassword">{{serverMessage}}</span>
      </div>
    </div>
    <p class="remind" id="{{id}}-main-click-forgot_password-link-popup_login-1" (click)="showRemindModal()">{{'user.signinup.remindPassNew'
      | translate}}</p>
    <button type="submit" id="{{id}}-main-click-login_email-button-popup_login-1" [ngClass]="{'loading': isDisabled}"
      [disabled]="authForm.invalid || isDisabled">
      <p *ngIf="!isDisabled">{{'user.signinup.signInNew' | translate}}</p>
      <lz-preloader *ngIf="isDisabled"></lz-preloader>
    </button>
    <div class="reg" *ngIf="!isSessionOver"><span id="{{id}}-main-click-to_register-link-popup_login-1" (click)="showRegModal()">{{'user.signinup.reg'
        | translate}}</span></div>
  </form>
  <section class="social-network">
    <div class="or"><span>{{'user.signinup.orBlock' | translate}}</span></div>
    <div class="social-network_icons">
      <div class="social-network_btn" id="{{id}}-main-click-login_fb-button-popup_login-1" (click)="getToken('/lzwpservice/authorize/authSN/facebook')">
        <i class="fa fa-facebook"></i>
      </div>
      <div class="social-network_btn" id="{{id}}-main-click-login_google-button-popup_login-1" (click)="getToken('/lzwpservice/authorize/authSN/google')">
        <i class="fa fa-google-plus"></i>
      </div>
      <!--<div class="social-network_btn" id="{{id}}-main-click-login_linkedin-button-popup_login-1" (click)="getToken('/lzwpservice/authorize/authSN/linkedin')">-->
        <!--<i class="fa fa-linkedin"></i>-->
      <!--</div>-->
    </div>
  </section>
</div>
`,
  styles: [`.lz-pl-container{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container{width:732px;padding:0}}@media (min-width:1002px){.lz-pl-container{width:976px}}@media (min-width:1490px){.lz-pl-container{width:1440px}}.lz-pl-container-new{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container-new{width:732px;padding:0}}@media (min-width:1200px){.lz-pl-container-new{width:1200px}}@media (min-width:1490px){.lz-pl-container-new{width:1440px}}.modal-lg{width:900px}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}*{text-shadow:none!important;margin:0;padding:0}body,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0;font-weight:400}ol,ul{list-style:none}img{max-width:100%;height:auto;vertical-align:middle}.h1,.h2,.h3,.h4,.h5,.h6,button,h1,h2,h3,h4,h5,h6,input,p,textarea{font-family:inherit;font-size:inherit;font-weight:inherit}input:focus,textarea:focus{outline:0}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{line-height:1.1}fieldset{border:none}::ng-deep .cdk-overlay-backdrop{background:rgba(0,0,0,.588)}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{margin:0;max-width:95vw;max-height:95vh;border-radius:0;background:rgba(0,0,0,0);-webkit-box-shadow:none;box-shadow:none;padding:0;overflow:visible;font-family:Geometria,sans-serif;font-weight:400}@media (max-width:1199px){::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{overflow-x:hidden}}@media (max-width:758px){::ng-deep .cdk-overlay-container .myPane{max-width:450px!important}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{max-width:450px}}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover{border:0;-webkit-text-fill-color:#fff;-webkit-box-shadow:0 0 0 1000px transparent inset;box-shadow:0 0 0 1000px transparent inset;-webkit-transition:background-color 5000s ease-in-out;transition:background-color 5000s ease-in-out;background:-webkit-linear-gradient(top,rgba(255,255,255,0) 0,rgba(0,174,255,.04) 50%,rgba(255,255,255,0) 51%,rgba(0,174,255,.03) 100%)}.login{padding:50px 30px;width:370px;max-width:100%;background:-webkit-gradient(linear,left bottom,left top,from(#3b60f7),to(#2741b0));background:linear-gradient(0deg,#3b60f7 0,#2741b0 100%);font-family:Geometria,sans-serif;font-weight:400;position:relative}.login .lz-logo{position:absolute;top:0;left:0}.login .lz-logo img{width:120%}.login .killed-session-text{color:#fff;font-size:18px;margin-bottom:15px;font-weight:700}.login h1{color:#fff;font-size:36px;font-weight:400;margin-bottom:32px}.login h1 span{font-weight:700}.login .close{position:absolute;border:1px solid #727dc7;color:#727dc7;right:20px;top:20px;width:35px;padding:5px;text-align:center;cursor:pointer}@media (max-width:321px){.login .close{right:45px}}.login label{width:100%}.login .form-group:first-child{margin-bottom:20px}.login .form-group{position:relative}.login .form-group .error-required{font-style:normal;font-weight:400;color:#ff564e;position:absolute;top:8px;left:0;z-index:0;font-size:14px;cursor:text}.login .form-group .error-field{position:absolute;color:#fff;background-color:#ff564e;font-size:12px;top:25px;width:100%;z-index:0}.login .form-group .error-field span{display:table;margin:3px;line-height:1}.login .form-label{width:100%;color:#fff;font-weight:bolder;font-size:14px;opacity:0}.login .form-group:focus-within label{opacity:0}.login .input-field{background-color:rgba(0,0,0,0);color:#fff;border:none;border-bottom:1px solid #fff;width:100%;height:30px;z-index:1}.login .input-field#name{margin-bottom:10px}.login .input-field.ng-invalid.ng-touched{border-bottom:1px solid #ff564e;color:#ff564e}.login .input-field:focus{border-bottom:1px solid #ffbe26}.login .input-field::-webkit-input-placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.login .input-field::-ms-input-placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.login .input-field::placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.login .input-field.ng-invalid.ng-touched::-webkit-input-placeholder{color:#ff564e}.login .input-field.ng-invalid.ng-touched::-ms-input-placeholder{color:#ff564e}.login .input-field.ng-invalid.ng-touched::placeholder{color:#ff564e}.login .input-field:focus::-webkit-input-placeholder{opacity:.5}.login .input-field:focus::-ms-input-placeholder{opacity:.5}.login .input-field:focus::placeholder{opacity:.5}.login .remind{color:#ffbe26;font-size:12px;margin-top:10px;margin-bottom:15px;cursor:pointer;display:table}.login button{width:100%;background-color:#ffbe26;color:#303f9f;text-transform:uppercase;padding:15px;border:none;font-size:16px;font-weight:800;margin-bottom:15px;letter-spacing:1px;display:flex;display:-webkit-box;display:-ms-flexbox;justify-content:center;-webkit-box-pack:center;-ms-flex-pack:center;text-align:-webkit-center;text-align:-moz-center;cursor:pointer}.login button p{width:100%}.login button.loading{padding:23.5px}.login .reg{color:#ffbe26;text-transform:uppercase;text-align:center;font-size:14px;font-weight:700;letter-spacing:1px;margin-bottom:45px}.login .reg span{cursor:pointer}.login .or{overflow:hidden;text-align:center;color:#b2b9f1;font-size:14px;letter-spacing:1px;font-weight:700;margin-bottom:15px}.login .or:after,.login .or:before{background-color:#576ae6;content:"";display:inline-block;height:2px;top:50px;width:50%}.login .or:before{right:.5em;margin-left:-50%;margin-right:5px}.login .or:after{left:.5em;margin-right:-50%;margin-left:5px}.login .social-network_icons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.login .social-network_icons .social-network_btn{width:85px;max-width:100%;color:#ffbe26;background-color:#596ceb;text-align:center;padding:20px 0;cursor:pointer;margin:0 20px}.login .social-network_icons .social-network_btn:hover{background-color:#fff}.login .social-network_icons .social-network_btn:hover .fa-facebook{color:#3b5998}.login .social-network_icons .social-network_btn:hover .fa-google-plus{color:#dd4b39}.login .social-network_icons .social-network_btn:hover .fa-linkedin{color:#0077b5}`]
})

export class LzAuthNewComponent implements OnInit {

  private lang: string;

  public authForm: FormGroup;
  public isDisabled: boolean = false;
  public userInfo: any;
  public isShowErrorLoginAndPassword: boolean = false;
  public EMAIL_REGEXP = /^[a-z0-9._-]+@[a-z0-9._-]+\.[a-z0-9]{2,}$/i;
  public PASS_REGEXP = '[^Ð°-ÑÐ-Ð¯ÑÐÐ-ÐÑ-ÑÒÒ]+';
  public serverMessage: string;
  private sub1: Subscription;
  private sub2: Subscription;
  private config;
  public isSessionOver;
  public id = '';

  constructor(private language: LzLanguageService,
    private dialogRef: MatDialogRef < LzAuthNewComponent > ,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService,
    private cookie: LzCookieService,
    private lzProductConfig: LzProductConfig
  ) {
    console.log("AUTH COMPONENT: constructor");
    this.userInfo = data.info;
    this.isSessionOver = data.isSessionOver;
    this.lang = this.language.identifyLanguage();
    this.config = lzProductConfig.getProductSettings();
    this.id = this.config['order_code'] || 'platforma';

  }

  ngOnInit() {

    this.authForm = new FormGroup({
      'email': new FormControl('', [Validators.required, Validators.pattern(this.EMAIL_REGEXP)]),
      'password': new FormControl('', [Validators.required, Validators.pattern(this.PASS_REGEXP)])
    });
    this.watchErrorRequired();

  }

  public getClearSearchParams = () : string => {
    let search = window.location.search;
    if(search.indexOf('type=auth') != -1) {
      search = search.replace('type=auth', '');
      if(search.indexOf('?&') != -1) {
        search = search.replace('?&', '?');
      }
    }
    if(search.indexOf('type=reg') != -1) {
      search = search.replace('type=reg', '');
      if(search.indexOf('?&') != -1) {
        search = search.replace('?&', '?');
      }
    }
    if(search.indexOf('type=test') != -1) {
      search = search.replace('type=test', '');
      if(search.indexOf('?&') != -1) {
        search = search.replace('?&', '?');
      }
    }
    return search;
  }

  signIn = () => {
    this.isDisabled = true;
    this.isShowErrorLoginAndPassword = false;
    if (this.authForm.invalid) {
      this.isShowErrorLoginAndPassword = true;
      return false;
    }
    this.data.doAuth(this.userInfo, (msg) => {
      this.serverMessage = msg.message;
      if (msg.isAuthorized) {
        if (!window['dataLayer']) {
          window['dataLayer'] = [];
        }
        window['dataLayer'].push({
          'event': 'autoEvent',
          'eventCategory': 'login',
          'eventAction': this.id,
          'eventLabel': this.cookie.getCookie('referer') ? decodeURIComponent(this.cookie.getCookie('referer')) : window.location.href
        });

        if (this.cookie.getCookie('referer')) {
          let ref = decodeURIComponent(this.cookie.getCookie('referer'));
          this.cookie.deleteCookie('referer');
          window.location.href = ref;
        } else {
          if (window.location.href.indexOf('type=auth') != -1 || window.location.href.indexOf('type=reg') != -1 || window.location.href.indexOf('type=test') != -1) {
            window.location.href = '/';
          } else {
            window.location.href = window.location.protocol + '//' + window.location.host + window.location.pathname + this.getClearSearchParams();
          }
        }
      } else {
        if (msg.message == 'ÐÐµÐ²ÑÑÐ½Ð¸Ð¹ Ð»Ð¾Ð³ÑÐ½ Ð°Ð±Ð¾ Ð¿Ð°ÑÐ¾Ð»Ñ' || msg.message == 'ÐÐµÐ²ÐµÑÐ½ÑÐ¹ Ð»Ð¾Ð³Ð¸Ð½ Ð¸Ð»Ð¸ Ð¿Ð°ÑÐ¾Ð»Ñ') {
          this.isShowErrorLoginAndPassword = true;
          this.isDisabled = false;
        } else {
          if ((msg.message.indexOf('ÐÐ°Ñ Ð»Ð¾Ð³Ð¸Ð½ Ð¸ Ð¿Ð°ÑÐ¾Ð»Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÑÑÑÑ Ð½Ð° Ð´ÑÑÐ³Ð¾Ð¼' + 1)) || (msg.message.indexOf('ÐÐ°Ñ Ð»Ð¾Ð³ÑÐ½ Ñ Ð¿Ð°ÑÐ¾Ð»Ñ Ð²Ð¸ÐºÐ¾ÑÐ¸ÑÑÐ¾Ð²ÑÑÑÑÑÑ Ð½Ð° ÑÐ½ÑÐ¾Ð¼Ñ' + 1))) {
            this.isShowErrorLoginAndPassword = true;
            this.isDisabled = false;
          }
        }
      }
    });


  };

  getToken = (service) => {
    location.href = service;
  };

  cancel = () => {
    this.dialogRef.close();
  };

  public showRemindModal = () => {
    let alias = '';
    if (this.data && this.data.alias) {
      alias = this.data.alias;
    }
    this.dialogRef.close();
    this.data.showRemind(alias);
  };

  public showRegModal = () => {
    let alias = '';
    if (this.data && this.data.alias) {
      alias = this.data.alias;
    }
    this.dialogRef.close();
    this.data.showReg(alias);
  };

  watchErrorRequired() {
    let values: Observable < number > = interval(100);

    let emailRequired: string;
    let passRequired: string;


    this.translate.get('user.signinup.emailRequired').subscribe(trans => emailRequired = trans);
    this.translate.get('user.signinup.passwordRequired').subscribe(trans => passRequired = trans);


    this.sub1 = values.subscribe(() => {

      if (this.authForm.get('email').invalid && this.authForm.get('email').touched &&
        this.authForm.get('email')['errors']['required']) {
        $('#e-mail').attr('placeholder', emailRequired);

      }
      if (this.authForm.get('password').invalid && this.authForm.get('password').touched &&
        this.authForm.get('password')['errors']['required']) {
        $('#password').attr('placeholder', passRequired);
      }

      if (this.userInfo && this.userInfo.email && this.userInfo.email.indexOf(' ') != -1) {
        this.userInfo.email = this.userInfo.email.replace(' ', '');
      }

    });

    this.sub2 = this.authForm.valueChanges.subscribe(() => {
      if (this.isShowErrorLoginAndPassword) {
        this.isShowErrorLoginAndPassword = false;
      }
    })
  }



  ngOnDestroy() {
    this.sub1.unsubscribe();
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
  }
}
